<template>
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.25415V11.5859C0 11.8804 0.238712 12.1191 0.533179 12.1191H4.79861C5.09307 12.1191 5.33179 12.3578 5.33179 12.6523V15.6305C5.33179 16.1055 5.90609 16.3434 6.24198 16.0075L12.9524 9.29706C13.1607 9.08884 13.1607 8.75125 12.9525 8.54303L6.24198 1.83256C5.90609 1.49667 5.33179 1.73456 5.33179 2.20957V5.18779C5.33179 5.48226 5.09307 5.72097 4.79861 5.72097H0.533179C0.238712 5.72097 0 5.95968 0 6.25415Z" fill="currentColor"/><path d="M11.0732 15.7283L14.2723 15.7283C16.0391 15.7283 17.4714 14.2961 17.4714 12.5293L17.4714 5.59794C17.4714 3.83114 16.0391 2.39887 14.2723 2.39887L11.0732 2.39887" stroke="currentColor" stroke-width="2.13271"/></svg>
</template>

<script>
export default {
  name: 'ArrowLogin'
}
</script>
